import {mixins} from "../app/mixin";

mixins.push({
    el: '#mobileMenu',
    data() {
        return {
            isMobileMenuOpen: false,
            device: {
                isMobile: false
            },
            selectedMenuId: 0,
            selectedSubMenuId: 0,
        }
    },
    methods: {
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;

            this.checkMobileMenuOpen();
        },
        closeMobileMenu() {
            this.isMobileMenuOpen = false;
            this.checkMobileMenuOpen();
        },
        checkMobileMenuOpen() {
            //TODO Saçma
            const element = document.getElementById("__layoutWrapper");
            const baseElement = document.getElementById('__baseLayoutWrapper');

            if (this.isMobileMenuOpen) {
                element.classList.remove("layoutWrapper");
                baseElement.classList.add('hide-important');
            } else {
                element.classList.add("layoutWrapper");
                baseElement.classList.remove('hide-important');
            }
        },
        selectMobileMenu(menuId) {
            if (menuId !== this.selectedMenuId && menuId < 4) {
                this.selectedMenuId = menuId;
            } else {
                this.selectedMenuId = -1;
            }
        },
        selectMobileSubMenu(subMenuId) {
            if (subMenuId !== this.selectedSubMenuId) {
                this.selectedSubMenuId = subMenuId;
            } else {
                this.selectedSubMenuId = -1;
            }
        }
    },
});